module.exports = __webpack_public_path__ + "img/LOGO_DETOURE.53846516.webp";